import Vue from "vue";
import Router from "vue-router";
import store from './store'

import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Home from "./views/Home";
import BrandView from "@/views/BrandView";
import CatalogView from "@/views/CatalogView";
import NewsView from "@/views/NewsView";
import NotificationsView from "@/views/NotificationsView";
import OrderView from "@/views/OrderView";
import CommodityView from "@/views/CommodityView";
import LoginView from "@/views/LoginView";
import ForgotPasswordView from "@/views/ForgotPasswordView";
import SearchView from "@/views/SearchView";
import HistoryView from "@/views/HistoryView";
import CustomerBillsView from "@/views/CustomerBillsView";
import SelectOrganizationView from "@/views/SelectOrganizationView";

import {wait} from './util/helpers'
console.log('Router CatalogView is:', CatalogView);
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: "active",
  routes: [
    {
      path: "*",
      name: "main",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/brand",
      name: "brand",
      components: {
        header: AppHeader,
        default: BrandView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/past",
      name: "past",
      components: {
        header: AppHeader,
        default: CatalogView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/latest",
      name: "latest",
      components: {
        header: AppHeader,
        default: CatalogView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/top_rank",
      name: "top_rank",
      components: {
        header: AppHeader,
        default: CatalogView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/closing_soon",
      name: "closing_soon",
      components: {
        header: AppHeader,
        default: CatalogView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/interest",
      name: "interest",
      components: {
        header: AppHeader,
        default: CatalogView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/favorite",
      name: "favorite",
      components: {
        header: AppHeader,
        default: CatalogView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/news",
      name: "news",
      components: {
        header: AppHeader,
        default: NewsView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/notifications",
      name: "notifications",
      components: {
        header: AppHeader,
        default: NotificationsView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/order",
      name: "order",
      components: {
        header: AppHeader,
        default: OrderView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/commodity/:id",
      name: "commodity",
      components: {
        header: AppHeader,
        default: CommodityView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/login",
      name: "login",
      components: {
        default: LoginView,
      },
    },
    {
      path: "/select-organization",
      name: "select-organization",
      components: {
        default: SelectOrganizationView,
      },
      meta: {
        authRequired: true,
        skipOrganizationCheck: true,
      },
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      components: {
        default: ForgotPasswordView,
      },
    },
    {
      path: "/search",
      name: "search",
      components: {
        header: AppHeader,
        default: SearchView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/history",
      name: "history",
      components: {
        header: AppHeader,
        default: HistoryView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/customer_bills",
      name: "customer_bills",
      components: {
        header: AppHeader,
        default: CustomerBillsView,
        footer: AppFooter
      },
      meta: {
        authRequired: true,
      },
    },
  ],
  scrollBehavior: to => {
    console.log('scrollBehavior', to, to.hash, to.hash.substring(1));
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.getElementById(to.hash.substring(1));
          console.log("element ", element);
          if (element) {
            element.scrollIntoView({behavior: 'smooth'});
          }
          resolve();
        }, 500); // 調整延遲時間以確保元素正確載入
      });
      // return { selector: to.hash };
    } else {
      return {x: 0, y: 0};
    }
  }
});

router.beforeEach(async (to, from, next) => {
  while (!store.state.isInit) {
    // console.log('\t|_ wait : ', store.state);
    await wait(100)
  }
  if (to.name === 'login' || to.name === 'forgot-password') {
    if (store.state.isAuthenticated) {
      return next({
        path: '/',
      })
    }
  }

  console.log('to : ', to);

  // return next()

  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.isAuthenticated) {
      return next({
        path: '/login',
      })
    }
    // 多門市帳號尚未選定門市時，先到選擇頁
    const org = store.state.myOrganization;
    const hasOrganization = org && org.id;
    if (!hasOrganization && !to.matched.some(record => record.meta.skipOrganizationCheck)) {
      return next({name: 'select-organization'})
    }
    return next()
  } else {
    return next()
  }
})


export default router;
